import React from "react";
import EventInfo from "./eventInfo";
import EntityInfo from "./entityInfo";

export default class MobileHomePage extends React.Component {

    state = {
        showInfo: false,
        MentionRelations: [],
        selectedMention: ''
    };

    getMentionRelations = (mention) => {
        const {edges,} = this.props;
        const infoboxRelations = [];

        edges.forEach(edge => {
            const sourceMention = edge.source['mention'];
            const targetMention = edge.target['mention'];
            if (mention === sourceMention) {
                infoboxRelations.push(edge)
            }
            if (mention === targetMention) {
                let temp = edge.source;
                edge.source = edge.target;
                edge.target = temp;
                infoboxRelations.push(edge)
            }
        });
        return infoboxRelations
    };

    clickMention = (data) => {
        const infoboxRelations = this.getMentionRelations(data.text);
        this.setState({
            MentionRelations: infoboxRelations,
            showInfo: infoboxRelations.length > 0,
            selectedMention: data.text
        })
    };

    hideInfo = () => {
        this.setState({showInfo: false})
    };


    render() {
        const {dailyList, selectIndex, event, selectDate,} = this.props;
        const {showInfo, selectedMention, MentionRelations} = this.state;

        return <div>
            {showInfo ?
                <EntityInfo
                    selectedMention={selectedMention}
                    MentionRelations={MentionRelations}
                    hideInfo={this.hideInfo}
                /> :
                <EventInfo
                    event={event}
                    dailyList={dailyList}
                    selectIndex={selectIndex}
                    selectDate={selectDate}
                    clickMention={this.clickMention}
                />}
        </div>
    }

}
